import useApiQuery from 'shared/hooks/use-api-query';
import companiesKeys from '../util/companies-keys';
import {CompanyNeighborHoodPriceProps} from '../types';

const useCompanyNeighborhoodPrices = (companyId: string) => {
  return useApiQuery<CompanyNeighborHoodPriceProps[]>({
    url: `/neighborhoods/company-prices/companies/${companyId}`,
    queryKey: companiesKeys.neighborhoodPrices(companyId),
  });
};

export default useCompanyNeighborhoodPrices;
